import { useRef } from "react";
import { FormInstance } from "antd";
import InterfaceComponent from "../../../Pages/Masters/InterfaceComponent";
import { ActionHandlerProvider } from "../../../Components/ActionHandlerContext";
import { API } from "../../../Axios/Axios";
import { fetchStaticTableData } from "../../../Helpers/APIEndpoints/Endpoints";

export default function EmployeeMaster() {
  const formRef = useRef<FormInstance>(null);

  const rowActionHandler = {
    FieldActionFunction: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("FieldActionFunction");
    }
  };

  const interfaceActionHandler = {
    GetTableInformation: async (actionType: string, ...params: any[]) => {
      //FetchStaticTableData
      try {

        let response = await API.post(fetchStaticTableData, {});

        if (response.data) {
          return response.data.data;
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error(`Failed to perform`, error);
        resolve(false);
      } finally {
        console.error(`Finally called`);
      }
      console.log(`${actionType} action with parameters:`, params);
      console.log("GetTableInformation run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      //return true;
    }
  }

  return (
    <ActionHandlerProvider
      interfaceActionHandler={interfaceActionHandler}
      rowActionHandler={rowActionHandler}
    >
      <InterfaceComponent
        InterfaceName={"Employee Master"}
        DashboardName={null}
        ref={formRef}
        Mode={"Create"}
      />
    </ActionHandlerProvider>
  );
}
